import _ from 'lodash'

export default {
  name: 'Sidebar',
  props: ['collapse'],
  computed: {
    expandWidth () {
      return this.collapse ? 'not-collapse-width' : 'collapse-width'
    },
    isDeviceChildren () {
      return _.startsWith(this.$route.path, '/device') || this.$route.path === '/'
    },
    isExportChildren () {
      return _.startsWith(this.$route.path, '/export')
    },
    isFirmwareChildren () {
      return _.startsWith(this.$route.path, '/firmware')
    },
    isIMChildren () {
      return _.startsWith(this.$route.path, '/informationModel')
    },
    isNotifyChildren () {
      return _.startsWith(this.$route.path, '/notifications')
    },
    isThemeChildren () {
      return _.startsWith(this.$route.path, '/theme')
    },
    isUserChildren () {
      return _.startsWith(this.$route.path, '/user')
    },
    showDevicesActive () {
      return [{ 'active': this.isDeviceChildren }]
    },
    showExportActive () {
      return [{ 'active': this.isExportChildren }]
    },
    showFirmwareActive () {
      return [{ 'active': this.isFirmwareChildren }]
    },
    showIMActive () {
      return [{ 'active': this.isIMChildren }]
    },
    showNotifyActive () {
      return [{ 'active': this.isNotifyChildren }]
    },
    showThemeActive () {
      return [{ 'active': this.isThemeChildren }]
    },
    showUsersActive () {
      return [{ 'active': this.isUserChildren }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js